import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../../utils/DataConstants';
import {
	walkthroughsRestCrudThunksForBuyer,
	walkthroughsRestCrudThunksForSupplier,
} from '../../../thunks/walkthroughs_thunks';
import {
	useWalkthroughNoteSender,
	useWalkthroughMentionSearch,
	useWalkthroughFileUpload,
} from '../../../hooks/useWalkthroughNoteSending';
import RowNotePreview from '../../row_note_preview/RowNotePreview';
import { getLinkWIthBackLinkParams } from '../../../utils/HistoryUtils';
import { withUserType } from '../../withUserType';
import { useNotesBroadcast } from '../../../hooks/useNotesBroadcast';
import { WEB_SOCKET_ENTITY_TYPES } from '../../../utils/WebSocketUtils';

interface WalkthroughRowNotePreviewProps {
	walkthrough: any;
	userType: string;
	refreshWalkthrough: (id: number) => void;
}

const WalkthroughRowNotePreview: React.FC<WalkthroughRowNotePreviewProps> = ({
	walkthrough,
	userType,
	refreshWalkthrough,
}) => {
	const location = useLocation();
	const history = useHistory();
	const { sendNote, sendNotesBulk, currentUser, walkthroughId } =
		useWalkthroughNoteSender(walkthrough);
	const { onSearch } = useWalkthroughMentionSearch(walkthrough);
	const { uploadFile } = useWalkthroughFileUpload(walkthroughId);
	const { onSendNote, onTyping } = useNotesBroadcast({
		entityIdName: 'walkthroughId',
		entityId: walkthroughId,
		entityType: WEB_SOCKET_ENTITY_TYPES.WALKTHROUGH_NOTES,
		newNoteEntityType: WEB_SOCKET_ENTITY_TYPES.WALKTHROUGH,
		currentUser,
	});

	return (
		<RowNotePreview
			lastNote={nullSafeGet('lastNote', walkthrough)}
			lastNoteAddedBy={nullSafeGet('lastNoteAddedBy', walkthrough)}
			lastNoteAddedAt={nullSafeGet('lastNoteAddedAt', walkthrough)}
			isLastNoteUnread={!!nullSafeGet('isLastNoteUnreadByCurrentUser', walkthrough)}
			isLastNoteAwaitingResponse={!!nullSafeGet('isLastNoteAwaitingResponse', walkthrough)}
			isLastNoteAwaitingResponseFromCurrentUser={
				!!nullSafeGet('isLastNoteAwaitingResponseFromCurrentUser', walkthrough)
			}
			isLastNoteResponsePending={!!nullSafeGet('isLastNoteResponsePending', walkthrough)}
			sendNote={sendNote}
			sendNotesBulk={sendNotesBulk}
			onMentionSearch={onSearch}
			currentUser={currentUser}
			entityId={walkthroughId}
			entityLabel={`Walkthrough #${walkthroughId}`}
			customUploadRequest={uploadFile}
			onWsSendNote={onSendNote}
			onWsTyping={onTyping}
			onNoteClick={() => {
				const path = `/${userType}/siteSurveys/walkthrough/detail/${walkthroughId}/notes`;
				history.push(getLinkWIthBackLinkParams(location, 'Back to Walkthroughs', path));
			}}
			onNoteSent={() => {
				const id = parseInt(nullSafeGet('id', walkthrough), 10);
				if (id) refreshWalkthrough(id);
			}}
		/>
	);
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	refreshWalkthrough: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? walkthroughsRestCrudThunksForSupplier.readOne(id)
				: walkthroughsRestCrudThunksForBuyer.readOne(id)
		),
});

export default withUserType(connect(null, mapDispatchToProps)(WalkthroughRowNotePreview as any));
